/* eslint-disable react/display-name */
import { lazy } from "react";

const TruckMonitoringPage = lazy(() => import("./pages/monitoring"));
const TruckRoutingOpPage = lazy(() => import("./pages/routing"));
const TruckReportPage = lazy(() => import("./pages/report"));
const TruckReport92015Page = lazy(() => import("./pages/report-92015"));
const TruckManagePageV2 = lazy(() => import("./pages/manage"));
const DriverManagePage = lazy(() => import("./pages/driver"));
const FirmwareManagePage = lazy(() => import("./pages/firmware"));
const DeviceManagePage = lazy(() => import("./pages/device"));
const EnterpriseReport = lazy(() => import("./pages/enterpriseReport"));
const DeviceStatusReport = lazy(() => import("./pages/deviceStatusReport"));
const DashboardPage = lazy(() => import("./pages/dashboard"));
const AssetPage = lazy(() => import("./pages/asset"));
const TruckRegisterPage = lazy(() => import("./pages/register"));
const SimManagePage = lazy(() => import("./pages/sim"));
const TruckDevicePage = lazy(() => import("./pages/truck-device"));
const TruckCameraMonitoringPage = lazy(
  () => import("./pages/truck-camera-monitoring")
);
const TruckCameraLogPage = lazy(() => import("./pages/truck-camera-log"));
const TruckTemperatureSensorPage = lazy(
  () => import("./pages/truck-temperature-sensor")
);
const TruckKpiGpsPage = lazy(() => import("./pages/truck-kpi-gps"));

const TruckRoutes = [
  { path: "registering", element: <TruckRegisterPage /> },
  { path: "assets", element: <AssetPage /> },
  { path: "dashboard", element: <DashboardPage /> },
  { path: "monitoring", element: <TruckMonitoringPage /> },
  { path: "routing", element: <TruckRoutingOpPage /> },
  { path: "manage/truck", element: <TruckManagePageV2 /> },
  { path: "manage/trucker", element: <DriverManagePage /> },
  { path: "manage/firmware", element: <FirmwareManagePage /> },
  { path: "manage/sim", element: <SimManagePage /> },
  { path: "manage/device", element: <DeviceManagePage /> },
  { path: "report/enterprise", element: <EnterpriseReport /> },
  { path: "report/device-status", element: <DeviceStatusReport /> },
  { path: "report/732014", element: <TruckReportPage /> },
  { path: "report/92015", element: <TruckReport92015Page /> },
  { path: "device-info", element: <TruckDevicePage /> },
  { path: "truck-camera-monitoring", element: <TruckCameraMonitoringPage /> },
  { path: "truck-camera-log", element: <TruckCameraLogPage /> },
  { path: "temperature-sensor", element: <TruckTemperatureSensorPage /> },
  { path: "kpi-gps", element: <TruckKpiGpsPage /> }
];
export default TruckRoutes;
